export default __webpack_public_path__ + "static/media/jana-dzurickova.41a66277.jpg";